<template>
  <section class="grid-flex">
    <section class="flex column w100">
      <div class="flex-1 flex row w100 middle">
        <div class="flex-1 w100">
          <div class="flex flex-1  middle margin-top-s">
            <div class="button primary" @click="openModalCreate()">
              Criar Link Rastreavel
            </div>
            <div class="flex column" style="margin-left: 16px">
              Quantidade de Links: {{ account.used_limits.limit_shortlink | number }} / {{ account.plan_limits.limit_shortlink | number }}
              <div class="no-mobile margin-top-s">Precisa de mais links? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
            </div>
          </div>
        </div>
        <div class="flex-1 flex w100 end filters-groupo-holder">
          <div class="flex flex-1 middle end">
            <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
          </div>
        </div>
      </div>
      <div class="flex w100 end">
        <div class="filters-groupo-holder">
          <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
          ></paginate>
        </div>
      </div>
      <div class="list-itens flex column w100">
        <div
          class="box flex-1 w100"
          v-for="(sl, index) in shortlinks"
          :key="index"
        >
        <div class="box-content">
          <div class="flex-1 w100">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    <p>
                      {{ sl.name }}
                    </p>
                    <div class="margin-top-s">
                      {{ sl.url }}
                    </div>
                  </div>
                  <div class="flex-2 flex w100 row  ">
                    <div class="flex-1 flex details">
                      <div class="flex column margin-top-s">
                        <div>
                          Url Encurtada
                        </div>
                        <div class="margin-top-s">
                          <b>{{ sl.short_url }}</b>
                        </div>
                      </div>
                    </div>
                    <!-- stats -->
                    <div class="flex-1 margin-top-s">
                      <div>
                        Cliques
                      </div>
                      <div class="margin-top-s">
                        {{ getClicks(sl.id) | number }}
                      </div>
                    </div>
                    </div>
                </div>
              </div>
              <div class="action margin-top-s">
                <div class="flex end">
                  <div class="button primary" @click="openToEdit(sl)">
                    EDITAR
                  </div>
                  <div
                    class="button primary"
                    @click="openToDelete(sl)"
                    style="margin-left: 8px"
                  >
                    DELETAR
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-if="isEmpty" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum link criado. Crie seu primeiro link para ter
            seus rastreamentos.
          </p>
        </div>
      </div>

      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
        </div>
      </div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      @close="closeToEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newShortLink.name"
                autocomplete="off"
              />
            </div>

            <div class="flex-1 w100 margin-top-m">
                <label>Dominio:</label>
                <select class="input" v-model="newShortLink.domain">
                  <option value="">Seleciona</option>
                  <option v-for="(f, index) in listDomains" :key="index" :value="f.domain" :selected="f.domain === newShortLink.domain">
                    {{ f.domain }}
                  </option>
                </select>
            </div>
            <div v-if="domainNotIsValid" class="flex-1 w100 marign-top-s">
              <b>Atenção:</b> Domínio selecionado não está validado. O link só vai funcionar depois da validação.
            </div>


            <div class="flex-1 w100 margin-top-m">
              <label>Url</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newShortLink.url"
                autocomplete="off"
              />
            </div>

            <div class="button secondary margin-top-m" @click="openUtmFields = !openUtmFields">
              {{ !openUtmFields ? 'Adicionar UTMS / SCK' : 'Fechar UTMS' }}
            </div>
            <div v-if="openUtmFields">
              
              <div class="flex-1 w100 margin-top-m">
                <label>utm_campaign</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newShortLink.utm_campaign"
                  autocomplete="off"
                />
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>utm_medium</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newShortLink.utm_medium"
                  autocomplete="off"
                />
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>utm_source</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newShortLink.utm_source"
                  autocomplete="off"
                />
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>utm_content</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newShortLink.utm_content"
                  autocomplete="off"
                />
              </div>

              <div class="flex-1 w100 margin-top-m">
                <label>utm_term</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newShortLink.utm_term"
                  autocomplete="off"
                />
              </div>
              <div class="flex-1 w100 margin-top-m">
              <label>SCK</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newShortLink.sck"
                autocomplete="off"
              />
            </div>

            <div class="flex-1 w100 margin-top-m">
              <label>SRC</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newShortLink.src"
                autocomplete="off"
              />
            </div>
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrUpdateShortLink()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Link?"
      @cancel="
        showModalDelete = false;
        selectedShortLink = null;
      "
      @accept="deleteShortLink(selectedShortLink.id)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import {
  getShortLinks,
  getShortLinksReport,
  createShortLink,
  updateShortLink,
  deleteShortLink,
} from "@/services/shortlink";

import {
  getDomains,
} from "@/services/domain";

const DEFAULTDOMAIN = 'l.lh4.me'
const EMPTY_SHORTLINK = {
  name: "",
  url: "",
  domain: DEFAULTDOMAIN,
  src: "",
  sck: "",
  utm_campaign: "",
  utm_medium: "",
  utm_source: "",
  utm_content: "",
  utm_term: "",
};

export default {
  name: "short-link",
  components: {
    Modal,
    ModalConfirm,
    ltkDatePicker,
  },
  data() {
    return {
      loading: false,
      loadingReport: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedShortLink: null,
      newShortLink: Object.assign({}, EMPTY_SHORTLINK),
      shortlinks: [],
      reportShortLinks: {},
      totalShortLinks: 0,
      domains: [],
      offset: 20,
      page: 1,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {
        },
      },
      openUtmFields: false,
    };
  },
  mounted() {
    this.getShortLinks();
    this.getShortLinksReport();
    this.getDomains();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.shortlinks = [];
        this.reportShortLinks = {};
        this.getShortLinks();
        this.getShortLinksReport();
      },
    },
    page: {
      handler() {
        this.shortlinks = [];
        this.getShortLinks();
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    domainNotIsValid() {
      if (this.newShortLink.domain == DEFAULTDOMAIN) {
        return false
      }

      let result = true

      this.domains.forEach(e => {
        if (e.domain === this.newShortLink.domain) {
          if (e.status === 'ACTIVE') {
            result = false
          }
        }
      });

      return result
    },
    titleModal() {
      return this.isEdit ? 'Editar Link': 'Criar Link'
    },
    isEmpty() {
      return this.totalShortLinks === 0 && !this.loading;
    },
    isEmptyDomain() {
      return this.domains && this.domains.length === 0
    },
    isEdit() {
      if (this.newShortLink && this.newShortLink.id) {
        return true
      }
      return false
    },
    totalPages() {
      let valueMode = this.totalShortLinks % this.offset;
      let value = this.totalShortLinks / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_shortlink <= this.account.used_limits.limit_shortlink) {
        return true
      }

      return false
    },
    listDomains() {
      var auxList = []

      auxList = this.domains.slice()
      auxList.push({
        id: 0,
        domain: DEFAULTDOMAIN,
        status: 'ACTIVE'
      })

      return auxList 
    }
  },
  methods: {
    getClicks(shId) {
      if (!this.reportShortLinks[shId]) {
        return '-'
      }

      return this.reportShortLinks[shId]['clicks']
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de links rastreaveis do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    openToDelete(sl) {
      this.showModalDelete = true;
      this.selectedShortLink = sl;
    },
    openToEdit(sl) {
      this.showModalCreateOrUpdate = true;
      this.newShortLink = sl;
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false;
      this.newShortLink = Object.assign({}, EMPTY_SHORTLINK);
    },
    saveOrUpdateShortLink() {
      if (this.isEdit) {
        this.updateShortLink(this.newShortLink.id);
      } else {
        this.createShortLink();
      }
      this.closeToEdit();
    },
    getDomains() {
      this.loadingDomain = true
      getDomains()
        .then((result) => {
          this.domains = result.domains
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loadingDomain = false
        })
    },
    getShortLinks() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: this.page,
        offset: this.offset,
      };
      getShortLinks(params)
        .then((result) => {
          this.shortlinks = result.shortlinks;
          this.totalShortLinks = result.total;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getShortLinksReport() {
      this.loadingReport = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: this.page,
        offset: this.offset,
      };

      getShortLinksReport(params)
        .then((result) => {
          this.reportShortLinks = result.logs
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loadingReport = false;
        });
    },
    createShortLink() {
      let params = {
        name: this.newShortLink.name,
        url: this.newShortLink.url,
        domain: this.newShortLink.domain,
        src: this.newShortLink.src,
        sck: this.newShortLink.sck,
        utm_campaign: this.newShortLink.utm_campaign,
        utm_source: this.newShortLink.utm_source,
        utm_medium: this.newShortLink.utm_medium,
        utm_content: this.newShortLink.utm_content,
        utm_term: this.newShortLink.utm_term,
      };
      createShortLink(params)
        .then((result) => {
          this.shortlinks.push(result);
          this.totalShortLinks = this.totalShortLinks + 1

          this.$toast.success({
            title: "Sucesso",
            message: "Link criado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateShortLink(shortId) {
      let params = {
        name: this.newShortLink.name,
        url: this.newShortLink.url,
        domain: this.newShortLink.domain,
        src: this.newShortLink.src,
        sck: this.newShortLink.sck,
        utm_campaign: this.newShortLink.utm_campaign,
        utm_source: this.newShortLink.utm_source,
        utm_medium: this.newShortLink.utm_medium,
        utm_content: this.newShortLink.utm_content,
        utm_term: this.newShortLink.utm_term,
      };

      updateShortLink(shortId, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Link editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteShortLink(shortId) {
      deleteShortLink(shortId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Link deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedShortLink = null;
          this.showModalDelete = false
        })
    },
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}

</style>
